export { default } from './TruckBodyStyleSection';
